import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=70cacc24&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=ts"
export * from "./recruit.vue?vue&type=script&lang=ts"
import style0 from "./recruit.vue?vue&type=style&index=0&id=70cacc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cacc24",
  null
  
)

export default component.exports